import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'details',
  initialState: {
    needRefetch: false,
  },
  reducers: {
    refetchStart(state) {
      state.needRefetch = true;
    },
    refetchSuccess(state) {
      state.needRefetch = false;
    },
  },
});

export const { refetchStart, refetchSuccess } = slice.actions;
export default slice.reducer;
